import { actionTypes } from './actions';

const initialState = {
  list: {
    loading: false,
    list: [],
    count: 0,
    params: {}
  },
  one: {
    loading: false,
    data: null
  }
};

const customersOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST: {
      const { payload = {} } = action;
      const { list = {} } = state;
      return {
        ...state,
        list: {
          ...list,
          ...payload
        }
      };
    }
    case actionTypes.CLEAR_ONE: {
      return {
        ...state,
        one: {
          loading: false,
          data: null
        }
      };
    }

    case actionTypes.DELETE_ONE:
    case actionTypes.CREATE_ONE:
    case actionTypes.GET_ONE: {
      const { one = {} } = state;
      const { payload = {} } = action;
      return {
        ...state,
        one: {
          ...one,
          ...payload
        }
      };
    }
    case actionTypes.UPDATE_ONE: {
      const { one = {} } = state;
      if (!one.data) return state;
      const { payload = {} } = action;
      return {
        ...state,
        one: {
          ...one,
          data: {
            ...one.data,
            ...payload
          }
        }
      };
    }
    default:
      return state;
  }
};

export default customersOrdersReducer;
